import { render, staticRenderFns } from "./AsociarEventosFormDetalle.vue?vue&type=template&id=1aab2f06&scoped=true&"
import script from "./AsociarEventosFormDetalle.vue?vue&type=script&lang=ts&"
export * from "./AsociarEventosFormDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarEventosFormDetalle.vue?vue&type=style&index=0&id=1aab2f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab2f06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1aab2f06', component.options)
    } else {
      api.reload('1aab2f06', component.options)
    }
    module.hot.accept("./AsociarEventosFormDetalle.vue?vue&type=template&id=1aab2f06&scoped=true&", function () {
      api.rerender('1aab2f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/AsociarEventosFormDetalle.vue"
export default component.exports